import { render, staticRenderFns } from "./MitApiKey.vue?vue&type=template&id=0873a0a4&scoped=true"
import script from "./MitApiKey.vue?vue&type=script&lang=js"
export * from "./MitApiKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873a0a4",
  null
  
)

export default component.exports